import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminApi, saveAdminToken } from '../../lib/admin-api';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { token, expires_at } = await adminApi.login(password);
      saveAdminToken(token, expires_at);
      navigate('/admin/settings');
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-md mx-auto py-12">
      <div className="text-center mb-8">
        <Link to="/" className="text-taupe text-sm hover:text-ink">
          ← Retour à la plateforme
        </Link>
      </div>

      <h2 className="font-serif text-3xl font-bold mb-2">Espace super-admin</h2>
      <p className="text-taupe mb-6 text-sm">
        Authentification interne par mot de passe. Donne accès aux paramètres plateforme
        (clés API, secrets de signature) injectés au runtime dans tous les Workers.
      </p>

      <form onSubmit={handleSubmit} className="card space-y-4">
        <div>
          <label htmlFor="password" className="block text-sm font-medium mb-1">
            Mot de passe super-admin
          </label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-border rounded px-3 py-2"
            required
          />
          <p className="text-xs text-taupe mt-1">
            Configuré via <code className="font-mono bg-cream/50 px-1">wrangler secret put MIZAN_ADMIN_PASSWORD</code>.
          </p>
        </div>

        {error && (
          <div className="text-sm text-red-800 border border-red-300 bg-red-50 rounded p-2">
            {error}
          </div>
        )}

        <button type="submit" disabled={loading || !password} className="btn-primary w-full">
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
